<template>
  <div class="project item timebird-trade">
    <div class="container custom">
      <div class="project__content list">
        <div class="project__content-breadcrumb" data-aos="fade">
          <el-breadcrumb separator="/">
            <template v-for="(item, index) in routeList">
              <el-breadcrumb-item v-if="item.meta.title" :key="index" :to="{ name: item.name }">
                {{ item.meta.title }}
              </el-breadcrumb-item>
            </template>
          </el-breadcrumb>
        </div>
        <div class="list__box">
          <div class="list__box-item" data-aos="fade-up">
            <div class="project__content-title">TBC Scan</div>
            <div class="project__content-subtitle">Blockchain Explorer - Tracking transactions on the Chain</div>
            <div class="project__content-text">
              TimeBird Chain is a private, independent network developed on the Hyperledge Besu platform that enables developers to deploy applications and execute smart contracts on the EVM. Complying with the Proof of Authority (QBFT) by validating the addresses and ownership of the nodes in the network, it helps to check new nodes and add them to the blockchain.
            </div>
            <div class="project__content-button">
              <a href="https://tbcscan.com/" target="_blank" class="btn btn-primary">Get started</a>
            </div>
          </div>
          <div class="list__box-item" data-aos="fade" data-aos-delay="500">
            <div class="project__content-image">
              <img class="mw100" src="/assets/images/project/tbc-scan-image.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="project__slide" data-aos="fade" data-aos-delay="300">
      <swiper :options="slideOption" class="project__slide-list">
        <swiper-slide class="list__item">
          <img src="/assets/images/project/tbc-scan-01.png" alt="">
        </swiper-slide>
        <swiper-slide class="list__item">
          <img src="/assets/images/project/tbc-scan-02.png" alt="">
        </swiper-slide>
        <swiper-slide class="list__item">
          <img src="/assets/images/project/tbc-scan-03.png" alt="">
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination"></div>
      </swiper>
      <p data-aos="fade-up">
        TBC Scan - TimeBird Chain Explorer helps Traders and Investors track public data of transactions on TimeBird’s network, demonstrating the transparency of Blockchain.
        <br>
        The professional interface having both light and dark mode provides brief information for traders/investors, such as daily transactions chart, average block time, total transactions, total blocks, and the number of wallet addresses on the network.
      </p>
    </div>
    <div class="solution" data-aos="fade">
      <div class="container-fluid">
        <swiper :options="solutionOption" class="solution__slide swiper__solution">
          <template v-for="(item, index) in listSolution">
            <swiper-slide :key="index" class="solution__slide-item">
              <div class="item__icon">
                <img :src="`/assets/images/project/${item.icon}.svg`" alt="">
              </div>
              <div class="item__title">{{ item.title }}</div>
              <div class="item__content">{{ item.text }}</div>
            </swiper-slide>
          </template>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <div class="project__feature">
      <div class="container custom">
        <div class="project__feature-title" data-aos="fade-up">8 Why to choose TBC Scan</div>
        <div class="project__feature-box">
          <div class="box__content">
            <template v-for="(item, index) in listFeature">
              <div class="box__content-list" data-aos="fade-right" :key="index">
                <div class="list__title" v-if="item.title">
                  <div class="icon">
                    <img src="/assets/images/layouts/icon-star.png" alt="icon">
                  </div>
                  {{ item.title }}
                </div>
                <template v-for="(_item, index) in item.listFeatureItem">
                  <div class="list__item" :key="index">
                    <div class="icon">
                      <img src="/assets/images/layouts/icon-bookmark.png" alt="icon">
                    </div>
                    {{ _item.title }}
                  </div>
                </template>
              </div>
            </template>
          </div>
          <div class="box__image" data-aos="fade-left">
            <img src="/assets/images/project/feature-image.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      active: 0,
      listFeature: [
        { title: 'TBC Scan provides real-time data to help traders/investors', listFeatureItem: [
          { title: 'Execute smart contract on TimeBird Chain directly' },
          { title: 'Look up the validity of smart contracts' },
          { title: 'Look up transactions and check the progress' },
          { title: 'Check wallet balance and any completed transactions' },
          { title: 'Follow and study NFT collections' },
          { title: 'Verify the supply of tokens and other cryptocurrencies' },
          { title: 'View the latest blocks added to the blockchain' },
          { title: 'Set up alerts for large-value transactions' },
        ]},
      ],
      listSolution: [
        { icon: 'solution-01', title: 'Blocks', text: 'Detailed information about priority fee, burnt fee, gas limit, gas used of blocks, uncle block, and forked block (Reorgs). Users can execute smart contracts on the chain directly instead of accessing other tools.' },
        { icon: 'solution-02', title: 'Transactions', text: 'Information about validated transactions, including transaction type, hash, wallet addresses, transaction fees, block number, and execution time.' },
        { icon: 'solution-03', title: 'Tokens', text: 'List of all tokens (including TBC) on the network. Traders can view details of total supply, holder count, contract info, balance, etc.' },
        { icon: 'solution-04', title: 'APIs', text: 'APIs document for developers on GraphQL, RPC, Eth RPC methods.' },
        { icon: 'solution-05', title: 'Utilities', text: 'Links to other utilities such as Wei Converter, Mnemonic, Blockchain Demo, Online Tools.' },
        { icon: 'solution-06', title: 'Ecosystem', text: 'Traders can experience on Mainnet Explorer, Testnet Explorer, Faucet, or exchange NFTs on TimeBird NFT Marketplace in the ecosystem.' },
      ],
      slideOption: {
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slideToClickedSlide: true,
        speed: 800,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: -20,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
          scale: 0.8
        },
        spaceBetween: 10,
        breakpoints: {
          480: {
            slidesPerView: 2
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      solutionOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        initialSlide: 0,
        centeredSlides: true,
        breakpoints: {
          576: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1680: {
            slidesPerView: 4,
            initialSlide: 1,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    }
  },
  computed: {
    routeList () {
      return this.$route.matched
    }
  },
  created() {
    setTimeout(() => {
      AOS.refreshHard()
    }, 100) 
  }
}
</script>